import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { areAllSelectedUsersServerAdmins, isSingleSelectSiteUserGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { siteUserEditSiteRole } from '../actions/SiteUserMenuActions';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export const SiteUserSiteRoleAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserSiteRole,
  translateName: Messages.siteRole_action,
  isVisible: (targetItems: ISiteUserInfo[], state: AppState) => {
    return targetItems.length > 0
      && SessionUserSelectors.canManageUsers(state)
      && !isSingleSelectSiteUserGuest(targetItems)
      && (!areAllSelectedUsersServerAdmins(targetItems) || SessionUserSelectors.isSessionServerAdmin(state));
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], state: AppState) => {
    return true;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserEditSiteRole(targetItems)
};
